export const preventSubmitOnSubmit = (authenticated, notify) => () => {
    if (!authenticated) {
        notify("Please sign in to use this service");
    } else {
        notify("Please go to the private page to use this service");
    }
}
